import React, { useState } from 'react';
import { useAppDispatch } from '../../../app/hooks';
import { fetchIntegrationData } from '../../../app/thunks/fetch-integration-data';
import { ReactComponent as IDAustriaLogo } from '../../../assets/images/IDAustriaIcon.svg';
import { useAppTranslation } from '../../../i18n';
import IdentificationMethodCard from './IdentificationMethodCard';

const TRANSLATION_PREFIX = 'steps.bank-auth-type-selection';

export const IDAustriaButton = () => {
	const { t } = useAppTranslation();
	const dispatch = useAppDispatch();
	const [submitting, setSubmitting] = useState<boolean>(false);

	const onClickIDAustria = async () => {
		try {
			setSubmitting(true);
			await dispatch(fetchIntegrationData());
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<IdentificationMethodCard
			id="id-austria-auth"
			icon={<IDAustriaLogo className="w-12 h-12" />}
			title={t(`${TRANSLATION_PREFIX}.id-austria-title`)}
			description={t(`${TRANSLATION_PREFIX}.id-austria-description`)}
			trustText={t(`${TRANSLATION_PREFIX}.id-austria-trust`)}
			onClick={onClickIDAustria}
			disabled={submitting}
		/>
	);
};

export default IDAustriaButton;
